import React, { Component } from "react";
import { Link } from "gatsby";
import { navigate } from "@reach/router";
import { getCurrentUser, logout } from "../services/Auth";
import { Form, Select, Button, Input, message } from "antd";
import { setUserData } from "../data/setUserData";

const AccountFeedback = ({ handleSubmit, props, stateProp }) => {
  const { Option } = Select;
  const { TextArea } = Input;
  const [form] = Form.useForm();
  const userData = setUserData();

  const validateMessages = {
    required: "Field is required!",
    types: {
      email: "${name} is not validate email!",
    },
  };

  const { loadings } = stateProp;
  if (stateProp.submited) {
    form.resetFields();
  }

  return (
    <>
      <div id="container__form" className="container container--1000 mart--xxl">
        <div
          className="action_status"
          style={{
            lineHeight: 1.7,
            textAlign: "center",
            fontSize: "18px",
            marginBottom: "45px",
          }}></div>
        <Form
          form={form}
          name="feed_back"
          size="large"
          validateMessages={validateMessages}
          onFinish={handleSubmit}
          initialValues={{ email: userData.email, guest_id: userData.guest_id }}
          scrollToFirstError>
          <div className="form__row">
            <div className="col col--50">
              <label className="label" htmlFor="email">
                {props.langData.placeholder_email}
              </label>
              <Form.Item name="email" id="email" rules={[{ required: true }]}>
                <Input className="input" disabled={true} />
              </Form.Item>
            </div>
          </div>
          <div className="form__row">
            <div className="col col--50">
              <label className="label" htmlFor="subject">
                {props.langData.placeholder_subject}
              </label>
              <Form.Item
                name="subject"
                id="subject"
                rules={[{ required: true }, { max: 200 }]}>
                <Input className="input" maxLength={200} />
              </Form.Item>
            </div>
          </div>
          <div className="form__row">
            <div className="col col--50">
              <label className="label" htmlFor="hotel">
                {props.langData.placeholder_hotel}
              </label>

              <Form.Item
                id="hotel_location"
                className=""
                name="reward_location"
                rules={[{ required: true }]}>
                <Select
                  showSearch
                  style={{ width: "100%" }}
                  placeholder={props.langData.placeholder_selected_hotel}
                  optionFilterProp="children"
                  className=""
                  bordered={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }>
                  {stateProp.rewardLocationItemData.length > 0 &&
                    stateProp.rewardLocationItemData.map((obj, index) => {
                      return (
                        <Option
                          value={`${obj.code}-${obj.name}`}
                          key={obj.code}>
                          {obj.name}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </div>
          </div>
          <div className="form__row">
            <label className="label" htmlFor="message">
              {props.langData.placeholder_message}
            </label>
            <Form.Item
              id="comment"
              className=""
              name="message"
              rules={[{ required: true }, { max: 500 }]}>
              <TextArea maxLength={500} autoSize={{ minRows: 3, maxRows: 5 }} />
            </Form.Item>
          </div>

          <div className="form__row text--center">
            <Form.Item name="guest_id" id="guest_id" hidden={true}>
              <Input className="input" />
            </Form.Item>
            <Button
              type="primary"
              className="button button--cta button"
              htmlType="submit"
              loading={loadings[0]}
              size="large">
              {props.langData.btn_label}
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
};

export default AccountFeedback;
